<motn-drawer-gap-from-top
  (clickedOutside$)="clickedOutside$.emit($event)"
>
  <div
    class="outer"
  >
    <div
      class="content devices"
    >
      <h3>
        Point Configuration
        <motn-pill color="indigo">Modbus TCP</motn-pill>
      </h3>

      @if (!getCurrentSelectedDevice()) {
        <div
          class="fake-select error"
          (click)="onDeviceMenuClick()"
        >
          &nbsp;
        </div>
      }

      @if (getCurrentSelectedDevice()) {
        <div
          class="fake-select"
          (click)="onDeviceMenuClick()"
          [innerText]="$safeNavigationMigration(getCurrentSelectedDevice()?.Name)"
        ></div>
      }

      @if (deviceMenuOptions) {
        <motn-popover-multi-select
          [multiOrSingle]="'single'"
          [optionGroup]="deviceMenuOptions"
          (clickedOutsideMenu$)="onDeviceMenuDone()"
          (clickedOption$)="onDeviceMenuDone(); onDeviceChange();"
        ></motn-popover-multi-select>
      }

      <div class="label">
        Device
        <span
          (click)="infoDevicesMenu()"
        >
          <i class="fa-regular fa-circle-info"></i>
        </span>
      </div>
    </div>

    @if (useCase) {
      <div
        class="content use-case"
      >
        <div class="subtitle">
          Edit device points<br>to create tiles for
        </div>

        <div class="title">
          {{useCase}}
        </div>
      </div>
    }
  </div>

  <div
    class="outer"
  >
    @if (filteredPoints) {
      <div
        class="content results"
      >
        <h3>
          <div class="text">
            Known Points

            <motn-pill>{{filteredPoints.length}}</motn-pill>

            @if (!selectionMode) {
              <button
                class="small green"
                (click)="addPoint()"
              >
                Add Point
              </button>
            }

            <div class="actions">
              @if (!isMobile() && hasToolsOptions() && !selectionMode) {
                <motn-menu-button
                  buttonClass="small"
                  [optionsFactory]="createToolsOptions"
                >
                  Tools
                  <i class="fa-regular fa-chevron-down"></i>
                </motn-menu-button>
              }
            </div>
          </div>

          <div class="search">
            <input
              class="small"
              placeholder="Search known points..."
              [(ngModel)]="searchTerm"
              (ngModelChange)="filterAndRenderPoints()"
            >
          </div>
        </h3>

        <motn-sort-table
          [table$]="table$"
        ></motn-sort-table>
      </div>
    }
  </div>
</motn-drawer-gap-from-top>

@if (editingPoint) {
  <motn-modbus-single-point
    [point]="editingPoint"
    [deviceId]="selectedDevice"
    [testingRead]="reading"
    (clickedOutside$)="editingPoint = null"
    (saved$)="onSave()"
    (testRead$)="onTestRead($event)"
    (testWrite$)="onTestWrite($event)"
    (testWriteFalse$)="onTestWrite($event, false)"
    (testWriteTrue$)="onTestWrite($event, true)"
  ></motn-modbus-single-point>
}

@if (editingTile) {
  <motn-tile-editor
    [tileId]="editingTile"
    (closed$)="editingTile = null"
    (deleted$)="editingTile = null"
  ></motn-tile-editor>
}
